
import React, {FC} from 'react';

import ThumbsDown from './svgs/down.inline.svg';
import ThumbsUp from './svgs/up.inline.svg';

import * as styles from './styles.module.scss';

type ThumbsProps = {
	onThumbs: (thumbs: 'up' | 'down') => void
}

export const Thumbs: FC<ThumbsProps> = ({onThumbs}) => {
	return (
		<div className={styles.thumbs}>
			<ThumbsUp onClick={() => onThumbs('up')} />
			<ThumbsDown onClick={() => onThumbs('down')} />
		</div>
	);
};
